import { Add, SmartToy } from "@mui/icons-material"
import { Box, Button, Divider, SxProps } from "@mui/material"
import { useStore } from "@priolo/jon"
import { FunctionComponent } from "react"
import chatSo from "stores/copilot/chat"
import layoutSo from "stores/layout"
import AgentSelector from "./history/AgentSelector"
import MessagesHistoryCmp from "./history/MessagesHistoryCmp"




const ZeroGptMenu: FunctionComponent = ({ }) => {

	// STORES
	useStore(layoutSo)


	// HOOKS


	// HANDLERS
	const handleAddChat = async () => {
		chatSo.createNewChat()
	}


	// RENDER
	return (
		<Box sx={sxRoot}>
		
			<Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 3, mb: 2 }}>
				{/* Agent Selector */}
				<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
					<SmartToy sx={{ ml: "12px" }} />
					<AgentSelector sx={{ flex: 1, fontWeight: 500 }} />
				</Box>

				<Button startIcon={<Add />} sx={{ alignSelf: "start" }} size="small"
					onClick={handleAddChat}
				>New Chat</Button>
			</Box>

			{/* Messages History */}
			<Box sx={sxHistoryTitle}>
				Chats
			</Box>

			<Divider sx={{ mb: 2}}/>

			<Box sx={sxHistory}>
				<MessagesHistoryCmp />
			</Box>

		</Box>
	)
}

export default ZeroGptMenu

const sxRoot: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	p: 1,
	height: '100%',
	overflow: 'hidden'
}

const sxHistoryTitle: SxProps = {
	ml: 2,
	fontSize: "12px",
	fontWeight: 500,
	color: "text.sub",
	mb: "5px",
}

const sxHistory: SxProps = {
	flex: 1,
	overflowY: 'auto',
}